document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    document.querySelectorAll('fg-tooltip').forEach((el) => {
      if (!(el instanceof FGTooltip)) return;
      el.closeTooltip();
    });
  });
});

class FGTooltip extends HTMLElement {
  /** @type{*} */
  #hideTimeout = null;
  /** @type{*} */
  #resizeTimeout = null;
  mobileBreakpoint = 750;
  desktopClass = '';
  mobileClass = '';

  constructor() {
    super();
  }

  connectedCallback() {
    const positionDesktop = this.dataset.positionDesktop ?? 'right';
    const positionMobile = this.dataset.positionMobile ?? 'top';
    const hoverDelay = this.dataset.hoverDelay ? parseInt(this.dataset.hoverDelay, 10) : 500;
    this.handleResize = this.handleResize.bind(this);

    this.desktopClass = `position-${positionDesktop}`;
    this.mobileClass = `position-${positionMobile}`;

    const isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;

    const contentElement = this.querySelector('.fg-tooltip-content');

    const initWindowWidth = window.innerWidth;
    if (initWindowWidth < this.mobileBreakpoint) {
      this.classList.add(this.mobileClass);
    } else {
      this.classList.add(this.desktopClass);
    }

    if (this.mobileClass !== this.desktopClass) {
      window.addEventListener('resize', this.handleResize);
    }

    if (!isTouchDevice) {
      this.addEventListener('mouseenter', event => {
        clearTimeout(this.#hideTimeout);
        contentElement?.classList.add('visible');
      });
      this.addEventListener('mouseleave', event => {
        this.#hideTimeout = setTimeout(() => {
          contentElement?.classList.remove('visible');
        }, hoverDelay);
      });
    } else {
      this.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (contentElement?.classList.contains('visible')) {
          contentElement?.classList.remove('visible');
        } else {
          contentElement?.classList.add('visible');
        }
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  closeTooltip() {
    const contentElement = this.querySelector('.fg-tooltip-content');
    contentElement?.classList.remove('visible');
  }

  /**
   * 
   * @param {Event} event 
   */
  handleResize(event) {
    clearTimeout(this.#resizeTimeout);
    this.#resizeTimeout = setTimeout(() => {
      const innerWidth = window.innerWidth;
      if (innerWidth < this.mobileBreakpoint) {
        this.classList.remove(this.desktopClass);
        this.classList.add(this.mobileClass);
      } else {
        this.classList.add(this.desktopClass);
        this.classList.remove(this.mobileClass);
      }
    }, 250);
  }
}

if (!customElements.get('fg-tooltip')) {
  customElements.define('fg-tooltip', FGTooltip);
}
